import $ from 'jquery';

export default class Video {
  constructor(config) {
    this._video = config.video[0];

    this._init();
  }

  _init() {
    var that = this;
    var fallbackImage = $(that._video).data('fallbackimage');
    var delay = $(that._video).data('delay');

    $(window).on('load', function() {
      if (that._video.readyState === 4) {
        setTimeout(function() {
          that._video.play();
        }, delay);
      } else {
        $(that._video).attr('poster', fallbackImage);
      }
    });
  }
}
